import PromotionModal from './promotion-modal';
export default PromotionModal;
